/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { HomeNav, HomeDrawer, Seo } from '@components/systems'

import { Toolbar } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { HomeNavMenuType } from '@redux/types'
import { useLocation } from 'react-router-dom'
import config from '@configs'

export const HomeLayout = (): JSX.Element => {
	// hook
	const location = useLocation()

	const menuList: HomeNavMenuType[] = config.homeMenu()

	return (
		<View css={style}>
			{/* 경로별 메타·canonical. 제품 페이지는 각자 JSON-LD 를 얹어 덮어쓴다. */}
			<Seo />

			<HomeDrawer menuList={menuList} />
			<View className="mainLayoutInnerView">
				<View className="TabContaxtOuterView">
					<HomeNav menuList={menuList} />

					<View className={'container'}>
						<Toolbar className="toobar" />
						<View className="containerInnerView">
							<Outlet />
						</View>
					</View>
				</View>
			</View>
		</View>
	)
}

const style = css({
	display: 'flex',
	position: 'relative',
	padding: 0,
	height: '100%',
	width: '100%',
	background: '#fff',

	'.mainLayoutInnerView': {
		position: 'relative',
		display: 'flex',
		height: '100%',
		width: '100%',
		minHeight: '100%',

		'.TabContaxtOuterView': {
			position: 'relative',
			width: '100%',
		},

		'.toobar': {
			minHeight: '5rem',
		},

		'.container': {
			position: 'relative',
			width: '100%',
			height: '100%',
			flexGrow: 1,
			background: '#fff',

			'.containerInnerView': {
				position: 'relative',
				zIndex: 3,
				width: '100%',
			},
		},
	},
})
